<template>
 <section>
   <el-menu
       :default-active="activeName"
       class="el-menu-demo"
       mode="horizontal"
       @select="handleSelect"
       background-color="#545c64"
       text-color="#fff"
       active-text-color="#ffd04b">
     <el-menu-item index="subscribe">RS超级订阅转换</el-menu-item>
     <el-menu-item index="parser">RS订阅解析服务</el-menu-item>
     <el-menu-item index="short">RS短链接服务</el-menu-item>
     <el-menu-item index="shadowrocket-qrcode">Shadowrocket二维码</el-menu-item>
   </el-menu>

   <sub-converter v-if="activeName === 'subscribe'"/>

   <my-short-urls  v-if="activeName === 'short'"/>

   <sub-parser  v-if="activeName === 'parser'"/>

   <shadowrocket-q-r-code  v-if="activeName === 'shadowrocket-qrcode'"/>

 </section>
</template>

<script>

import SubConverter from "@/views/SubConverter.vue";
import MyShortUrls from "@/views/MyShortUrls.vue";
import SubParser from "@/views/SubParser.vue";
import ShadowrocketQRCode from "@/views/ShadowrocketQRCode.vue";

export default {
  components: {SubConverter, MyShortUrls, SubParser, ShadowrocketQRCode},
  data() {
    return {
      activeName: 'subscribe',
    };
  },

  created() {
  },
  mounted() {
    if (process.env.VUE_APP_USE_STORAGE === 'true') {
      let activeName = this.getLocalStorageItem('RS_Tab_Active_Name')
      if(activeName){
        this.activeName = activeName;
      }
    }
  },
  methods: {
    handleSelect(key, keyPath) {
      this.activeName = key;

      if (this.activeName !== '') {
        this.setLocalStorageItem('RS_Tab_Active_Name', this.activeName)
      }
    },

    getLocalStorageItem(itemKey) {
      const now = +new Date()
      let ls = localStorage.getItem(itemKey)

      let itemValue = ''
      if (ls !== null) {
        let data = JSON.parse(ls)
        if (data.expire > now) {
          itemValue = data.value
        } else {
          localStorage.removeItem(itemKey)
        }
      }

      return itemValue
    },
    setLocalStorageItem(itemKey, itemValue) {
      const ttl = process.env.VUE_APP_CACHE_TTL
      const now = +new Date()

      let data = {
        setTime: now,
        ttl: parseInt(ttl),
        expire: now + ttl * 1000,
        value: itemValue
      }
      localStorage.setItem(itemKey, JSON.stringify(data))
    },
  }
};
</script>


<style scoped>

</style>
